import { Injectable } from '@angular/core';
import { LocalStorageService } from './localstorage.service';
import _, { initial } from 'lodash';
import moment from 'moment';
import userflow from 'userflow.js';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class TourService {
    constructor(private localStorageService: LocalStorageService) {
        this.initialize();
    }

    initialize(): void {
        try {
            userflow.init(environment.userflow);
            this.identifyUser();
        } catch (error) {
            console.log('Userflow initialization error:', error);
        }
    }

    identifyUser(): void {
        const logged_in_user = this.localStorageService.getLocalStorage('user');
        const company = this.localStorageService.getLocalStorage('company');
        const modules = this.localStorageService.getLocalStorage('company_modules');
        const company_policy = this.localStorageService.getLocalStorage('company_policy');
        const company_modules = _.chain(modules).map('module').map('module_key').value();
        const company_config = this.localStorageService.getLocalStorage('company_configuration_data');
        let user_permissions: any = [], permissions: any;
        if(!_.isEmpty(logged_in_user) && logged_in_user.access_role && !_.isEmpty(logged_in_user.access_role)) {
            user_permissions = this.localStorageService.getLocalStorage('user_permissions');
            permissions = _.chain(user_permissions).map('permissions').map('permission_key').value();
        }
        const config: any = {}, policy: any = {};
        if(!_.isEmpty(company_config)) {
            if(company_config && company_config.jobs) {
                if(company_config.jobs.hasOwnProperty('allow_recurring_job')){
                    config.allow_recurring_job = company_config.jobs.allow_recurring_job;
                }
                else {
                    config.allow_recurring_job = true;
                }
            }
            if(company_config && company_config.invoice) {
                if(company_config.invoice.hasOwnProperty('enable_payment_link')){
                    config.enable_payment_link = company_config.invoice.enable_payment_link;
                }
                else {
                    config.enable_payment_link = false;
                }
            }
        }
        if(!_.isEmpty(company_policy)) {
            if(company_policy && company_policy.hasOwnProperty('service_task_enabled')) {
                policy.service_task_enabled = company_policy.service_task_enabled
            }
            else {
                policy.service_task_enabled = false;
            }
            if(company_policy && company_policy.hasOwnProperty('proposal_enabled')) {
                policy.proposal_enabled = company_policy.proposal_enabled
            }
            else {
                policy.proposal_enabled = false;
            }
        }
        if(!_.isEmpty(logged_in_user) && (company && company.company_login_name) && (company_modules && company_modules.length>0)) {
            let payload: any = {
                name: logged_in_user.first_name + ' ' + (logged_in_user.last_name || ''),
                created_at: moment(logged_in_user.created_at).format('YYYY-MM-DD HH:mm:ss'),
                email: logged_in_user.email,
                company_login_name: company.company_login_name,
                version: "v3",
                modules: {"append": company_modules},
                role: logged_in_user.role.role_key,
                allow_recurring_job: config.allow_recurring_job,
                enable_payment_link: config.enable_payment_link,
                service_task_enabled: policy.service_task_enabled,
                proposal_enabled: policy.proposal_enabled
            }
            if(company && company.company_industry) {
                payload.company_industry = company.company_industry;
            }
            if(permissions && permissions.length>0) {
                payload.permissions = {"append": permissions}
            }
            if((window as any).userflow) {
                try {
                    if((window as any).userflow.isIdentified() === true) {
                        const existing_payload = this.localStorageService.getLocalStorage('tour_attributes');
                        if(existing_payload && existing_payload.modules && existing_payload.modules.append) {
                            const added_modules = _.difference(company_modules, existing_payload.modules.append);
                            const removed_modules = _.difference(existing_payload.modules.append, company_modules);
                            if(added_modules.length > 0 ){
                                payload.modules = {
                                    "append" : company_modules
                                }
                                this.localStorageService.setLocalStorage('tour_attributes', payload)
                                userflow.updateUser(payload)
                            }
                            if(removed_modules.length > 0){
                                payload.modules = {
                                    "remove" : removed_modules
                                }
                                userflow.updateUser(payload)
                            }
                        }
                        else {
                            payload.modules = {
                                "append" : company_modules
                            }
                            this.localStorageService.setLocalStorage('tour_attributes', payload)
                            userflow.updateUser(payload)
                        }
                        if(existing_payload && existing_payload.permissions) {
                            const added_permissions = _.difference(permissions, existing_payload.permissions.append);
                            const removed_permissions = _.difference(existing_payload.permissions.append, permissions);
                            if(added_permissions.length > 0 ){
                                payload.permissions = {
                                    "append" : permissions
                                }
                                userflow.updateUser(payload)
                                this.localStorageService.setLocalStorage('tour_attributes', payload)
                            }
                            if(removed_permissions.length > 0){
                                payload.permissions = {
                                    "remove" : removed_permissions
                                }
                            }
                        }
                        else if(permissions && permissions.length > 0){
                            payload.permissions = {
                                "append" : permissions
                            }
                            userflow.updateUser(payload)
                            this.localStorageService.setLocalStorage('tour_attributes', payload)
                        }
                        userflow.updateUser(payload)
                    }
                    else if((window as any).userflow.identify) {
                        this.localStorageService.setLocalStorage('tour_attributes', payload)
                        userflow.identify(logged_in_user.user_uid, payload);
                    }
                }
                catch(error) {
                    console.log('Userflow identify/update error:', error);
                }

            }
        }
    }
}

